export default __webpack_public_path__ + "static/media/Elements_09.5edc6169.png";